import { __read, __spread } from "tslib";
export function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return a(b.apply(void 0, __spread(args)));
    }; });
}
//# sourceMappingURL=functional.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/core/dist/esm/utils/functional.js
// module id = 1230
// module chunks = 0